import { api } from 'boot/axios'
import Notify from 'quasar/src/plugins/Notify.js';
import { isSubscriptionBlocked } from 'src/logic/subscription'

import triesModule from './tries'

const MAX_TRIES = 1

export default {
  namespaced: true,

  modules: {
    triesModule,
  },

  state: {
    finish: false,

    // STATIC: only setItems
    functionalRoles: [],
    offices: [],
    productTypes: [],
    proveniences: [],
    statuses: [],
    users: [],
  },

  getters: {
    keys: state => Object.keys(state).filter(key => !key.endsWith('Module') && key !== 'finish'),

    findIndex: state => ({ key, id }) => state[key].findIndex(({ value }) => value === Number(id)),
    find: state => ({ key, id }) => state[key].find(({ value }) => value === Number(id)),

    getObj: (_, { find, findIndex }) => params => findIndex(params) === -1 ? {} : find(params),
    getObjLabel: (_, { getObj }) => (id, key) => getObj({ id, key }).label,
    getObjProp: (_, { getObj }) => ({ prop, ...params }) => getObj(params)[prop],

    forSelect: state => key => state[key].map(({ label, value }) => ({ label, value })),

    keyValue: state => key => state[key].reduce((res, { label, value }) => {
      res[value] = label
      return res
    }, {}),
  },

  actions: {
    async init({ getters: { keys }, dispatch, commit }) {
      await Promise.all(keys.map(key => dispatch('fetch', { key })))
      commit('FINISH', true)
    },

    async clear({ getters: { keys }, commit }) {
      await Promise.all(keys.map(key => commit('SET_ITEMS', { key, data: [] })))
      commit('FINISH', false)
    },

    async fetch({ state, commit, dispatch, getters }, { key, force = false }) {
      if (state[key].length === 0 || force) {
        try {
          dispatch('triesModule/init', key)
          const { data } = await api.get(key)
          commit('SET_ITEMS', { key, data })
        } catch (error) {
          // canone non pagato: l'interceptor porta già alla pagina di blocco
          if (isSubscriptionBlocked(error)) return
          dispatch('triesModule/increase', key)
          const tries = getters['triesModule/getTries'](key)
          if (tries <= MAX_TRIES) return dispatch('fetch', { key })
          else {
            Notify.create({
              color: 'negative',
              position: 'bottom-right',
              message: 'Si è verificato un errore. Contattare il supporto tecnico',
              caption: `Tentativo: ${tries - 1} - key: ${key}`,
              timeout: 0,
              actions: [
                { label: 'Ignora', color: 'white' },
                { label: 'Riprova', color: 'yellow', handler: () => dispatch('fetch', { key }) },
              ],
            })
          }
        }
      }
    },
  },
  mutations: {
    SET_ITEMS(state, { key, data }) { state[key] = data },
    ADD_ITEM(state, { key, item }) { state[key].push(item) },
    FINISH(state, finish) { state.finish = finish },
  },
}
